import { render, staticRenderFns } from "./bookerPackages.vue?vue&type=template&id=04dd0932&scoped=true"
import script from "./bookerPackages.vue?vue&type=script&setup=true&lang=js"
export * from "./bookerPackages.vue?vue&type=script&setup=true&lang=js"
import style0 from "./bookerPackages.vue?vue&type=style&index=0&id=04dd0932&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dd0932",
  null
  
)

export default component.exports